import gql from 'graphql-tag';
import userInfoFragment from '../user/userInfo';

export default gql`
  fragment reportInfo on Report {
    id
    type
    createdAt
    relativeId
    reporter {
      ...userInfo
    }
    content {
      body
    }
    link
  }
  ${userInfoFragment}
`;
